module.exports = __webpack_public_path__ + "img/icon-404.0e392efa.png";